import { Link } from "gatsby";
import moment from "moment";
import React, { useState } from "react";

import { FaFacebook } from "../../AppReactIcons";
import {
  MCHRI_Facebook_ExternalLink,
  TermsAndConditionsUpdateS3_ExternalLink,
} from "../../utils/urls";
import SiteContainer from "../SiteContainer";
import { LightBlueAppButtonNoHover } from "../buttons";
import { MonashHealthLogo } from "../logos";
import { HealthDirectLogo } from "../logos/HealthDirectlogo";
import { MCHRILogo } from "../logos/MCHRILogo";
import { MonashUniversityLogo } from "../logos/MonashUniversityLogo";
import { ContentSeparator } from "../pageComponents/Utils/ContentSeparator";

const Content = () => {
  const [show, setShow] = useState(false);
  if (!show) {
    return (
      <p className="text-sm">
        This information is informed by the National Health and Medical Research
        Council (NHMRC) approved evidence-based guidelines, community preference
        and multidisciplinary clinical expertise in PCOS. MCHRI (Monash Center
        for Health Research and Implementation) and Monash University provide
        the AskPCOS application...&nbsp;
        <span
          onClick={() => setShow(!show)}
          className="inline-block font-bold cursor-pointer hover:underline"
        >
          Read more
        </span>
      </p>
    );
  } else {
    return (
      <>
        <p className="text-sm">
          This information is informed by the National Health and Medical
          Research Council (NHMRC) approved evidence-based guidelines, community
          preference and multidisciplinary clinical expertise in PCOS. MCHRI
          (Monash Center for Health Research and Implementation) and Monash
          University provide the AskPCOS application.
        </p>
        <br />
        <p className="text-sm">
          It is designed to be informative and educational, not to provide
          specific medical advice or to replace individual health practitioner
          advice. MCHRI explicitly does not warrant the accuracy of the
          information contained in this app. MCHRI does not give medical advice,
          nor do we provide medical or diagnostic services. Medical information
          changes rapidly. Neither we nor our authors guarantee that the content
          covers all possible uses, directions, precautions, drug interactions,
          or adverse effects that may be associated with any therapeutic
          treatments. Your reliance upon information and content obtained by you
          at or through this site is solely at your own risk. Neither we nor our
          authors assume any liability or responsibility for damage or injury
          (including death) to you, other persons or property arising from any
          use of any product, information, idea or instruction contained in the
          content or services provided to you.&nbsp;
          <span
            onClick={() => setShow(!show)}
            className="inline-block font-bold cursor-pointer hover:underline"
          >
            Read less
          </span>
        </p>
      </>
    );
  }
};

const DisclaimerContent: React.FC = () => {
  return (
    <div>
      <p className="text-lg">
        <strong>Disclaimer</strong>
      </p>
      <Content />
    </div>
  );
};

const FooterPanel_FooterConclusion = () => {
  return (
    <div className="text-center md:text-left col-span-1 lg:col-span-2">
      <div className="flex justify-center md:justify-start">
        <Link to="/">
          <h1 className="text-white text-4xl">AskPCOS</h1>
        </Link>
      </div>
      <p>
        <strong>AskPCOS</strong> is your personal guide to PCOS.
      </p>
      <br />
      <DisclaimerContent />
      <div className="hidden md:block">
        <br />
      </div>
      <p className="text-xs text-center md:text-left hidden md:block">
        All rights reserved &copy; {moment(new Date()).format("YYYY")}
      </p>
    </div>
  );
};

const FooterPanel_PoweredBy = () => {
  return (
    <div>
      <h1 className="text-white text-lg hidden md:block">Powered by</h1>
      <ContentSeparator />
      <div className="flex justify-center md:justify-start">
        <div className="flex items-center flex-wrap justify-center md:justify-start">
          <div
            className="rounded-lg flex items-center justify-center mb-2"
            style={{
              backgroundColor: "#eeeeee",
              height: "70px",
              width: "120px",
            }}
          >
            <MCHRILogo width={100} />
          </div>
          <div className="mx-1" />
          <div
            className="rounded-lg flex items-center justify-center mb-2"
            style={{
              backgroundColor: "#eeeeee",
              height: "70px",
              width: "120px",
            }}
          >
            <MonashHealthLogo width={100} />
          </div>
          <div className="mx-1" />
          <div
            className="rounded-lg flex items-center justify-center mb-2"
            style={{
              backgroundColor: "#eeeeee",
              height: "70px",
              width: "120px",
            }}
          >
            <MonashUniversityLogo width={100} />
          </div>
        </div>
      </div>
      <div className="py-1" />
      <div className="flex items-center justify-center md:justify-start">
        <a rel="noopener" href={MCHRI_Facebook_ExternalLink} target="_blank">
          <LightBlueAppButtonNoHover
            Icon={<FaFacebook />}
            title="Follow us on facebook"
          />
        </a>
      </div>
      <ContentSeparator />
      <p className="text-xs text-center md:text-left md:hidden block mb-4">
        All rights reserved &copy; {moment(new Date()).format("YYYY")}
      </p>
      <p className="text-xs text-center md:text-left mb-1">
        Get in touch with us at{" "}
        <a
          className="hover:underline font-bold"
          href="mailto:info.mchri@monash.edu"
          target="_blank"
          rel="noreferrer"
        >
          info.mchri@monash.edu
        </a>
      </p>
      <p className="text-xs text-center md:text-left  mb-1">
        See AskPCOS{" "}
        <a
          className="hover:underline font-bold"
          href={TermsAndConditionsUpdateS3_ExternalLink}
          target="_blank"
          rel="noreferrer"
        >
          terms of use &amp; privacy policy
        </a>
      </p>
      <p className="text-xs text-center md:text-left">
        Images by{" "}
        <a
          href="https://www.pexels.com/"
          className="hover:underline font-bold"
          target="_blank"
        >
          pexels.com
        </a>
      </p>
      <div className="flex justify-center md:justify-start my-2">
        <div className="mx-1 lg:mx-0" />
        <div
          className="rounded-lg flex items-center justify-center mb-2"
          style={{
            backgroundColor: "#eeeeee",
            height: "80px",
            width: "250px",
          }}
        >
          <HealthDirectLogo width={250} />
        </div>
      </div>
    </div>
  );
};

const FooterView = () => {
  return (
    <footer>
      <SiteContainer className="bg-site-blue-dark text-white ">
        <div className="py-12">
          <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <FooterPanel_FooterConclusion />
            <FooterPanel_PoweredBy />
          </div>
        </div>
      </SiteContainer>
    </footer>
  );
};

const Footer = () => {
  return <FooterView />;
};

export default Footer;
